/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-11-17 11:28:35
 * @LastEditors: Jack Deng
 * @LastEditTime: 2021-11-19 18:13:46
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelContentEditor/SalesChannelEditorHeader/HoverStyle/index.tsx
 */
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import ColorPicker from 'src/components/ColorPicker/ColorPicker';
import Switcher from 'src/components/SectionSwitcher';
import ErrorProcessingHOC from 'src/constrains/SalesChannelPreviewPageComponents/ErrorProcessingHOC';
import ItemWrapper from 'src/constrains/SalesChannelPreviewPageComponents/OverwriteItemWrapper';
import Section from 'src/constrains/SalesChannelPreviewPageComponents/SectionContainer';
import { useI18n } from 'src/hooks/useRouterChange';
import { store } from 'src/store';
import { getI18nFromGeneral, i18nGet } from 'src/tools/tools';
import {
  getCollapseOpenStatus,
  getCollapseValidationMsgDisplay,
  getHoverStyle,
  getSubmitStamp,
  onCollapseOpen,
  onErrorChange,
  onFixedFieldChange,
  resetConfig,
} from '../slice';
import { SalesChannelEditorHeaderEnum, hoverStyleValidation } from '../tool';
function HoverStyle(props: any) {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const [s, setS] = useState('logoBarColor');
  const { data } = props;
  const _d = useDispatch();
  return (
    <React.Fragment>
      <Section bottomBorder>
        <Switcher
          selected={s}
          onChange={(v) => setS(v)}
          allSections={{
            logoBarColor: {
              title: getI18n('salesChannelContent.index.logoBarColour'),
              hasError: false,
              child: (
                <React.Fragment>
                  <ItemWrapper title={getI18n('general.backgroundColour')}>
                    <ColorPicker
                      multi
                      onChange={(v) => {
                        _d(
                          onFixedFieldChange({
                            path: 'hoverStyle.logoBarColor.backgroundColor',
                            value: v,
                          }),
                        );
                      }}
                      color={data?.logoBarColor?.backgroundColor}
                    />
                  </ItemWrapper>
                  <ItemWrapper
                    title={getI18n('salesChannelContent.index.textIconColour')}>
                    <ColorPicker
                      multi
                      onChange={(v) => {
                        _d(
                          onFixedFieldChange({
                            path: 'hoverStyle.logoBarColor.textColor',
                            value: v,
                          }),
                        );
                      }}
                      color={data?.logoBarColor?.textColor}
                    />
                  </ItemWrapper>
                  <ItemWrapper
                    title={getI18n('salesChannelContent.index.dividerColour')}>
                    <ColorPicker
                      multi
                      onChange={(v) => {
                        _d(
                          onFixedFieldChange({
                            path: 'hoverStyle.logoBarColor.dividerColor',
                            value: v,
                          }),
                        );
                      }}
                      color={data?.logoBarColor?.dividerColor}
                    />
                  </ItemWrapper>
                  <ItemWrapper
                    title={getI18n(
                      'salesChannelContent.index.languageSelectorOutlineColour',
                    )}>
                    <ColorPicker
                      multi
                      onChange={(v) => {
                        _d(
                          onFixedFieldChange({
                            path: 'hoverStyle.logoBarColor.outlineColor',
                            value: v,
                          }),
                        );
                      }}
                      color={data?.logoBarColor?.outlineColor}
                    />
                  </ItemWrapper>
                </React.Fragment>
              ),
            },
            menuBarColor: {
              title: getI18n('salesChannelContent.index.menuBarColour'),
              hasError: false,
              child: (
                <React.Fragment>
                  <ItemWrapper title={getI18n('general.backgroundColour')}>
                    <ColorPicker
                      multi
                      onChange={(v) => {
                        _d(
                          onFixedFieldChange({
                            path: 'hoverStyle.menuBarColor.backgroundColor',
                            value: v,
                          }),
                        );
                      }}
                      color={data?.menuBarColor?.backgroundColor}
                    />
                  </ItemWrapper>
                  <ItemWrapper title={getI18n('general.textColour')}>
                    <ColorPicker
                      multi
                      onChange={(v) => {
                        _d(
                          onFixedFieldChange({
                            path: 'hoverStyle.menuBarColor.textColor',
                            value: v,
                          }),
                        );
                      }}
                      color={data?.menuBarColor?.textColor}
                    />
                  </ItemWrapper>
                  <ItemWrapper
                    title={getI18n(
                      'salesChannelContent.index.searchBarOutlineColour',
                    )}>
                    <ColorPicker
                      multi
                      onChange={(v) => {
                        _d(
                          onFixedFieldChange({
                            path: 'hoverStyle.menuBarColor.outlineColor',
                            value: v,
                          }),
                        );
                      }}
                      color={data?.menuBarColor?.outlineColor}
                    />
                  </ItemWrapper>
                </React.Fragment>
              ),
            },
          }}
        />
      </Section>
    </React.Fragment>
  );
}

export default (props) =>
  ErrorProcessingHOC(HoverStyle, {
    getCollapseOpenStatus,
    onCollapseOpen,
    expandOffset: props.isResponsive ? 0 : undefined,
    id: SalesChannelEditorHeaderEnum.hoverStyle,
    getContent: getHoverStyle,
    title: getI18nFromGeneral('general.hOCTitle.hoverStyle'),
    getErrorDisplay: getCollapseValidationMsgDisplay,
    onErrorChange,
    getSubmitStamp,
    validation: (x) => {
      return hoverStyleValidation(x);
    },
    headerProps: {
      dotsFunction: [
        {
          onClick: () => {
            store.dispatch(resetConfig({ key: 'hoverStyle' }));
          },
          key: 'Reset Style',
          body: getI18nFromGeneral('general.hOCTitle.resetStyle'),
          isDangerous: true,
        },
      ],
      hasDots: true,
      hideDotsWhenNotPrimary: true,
    },
  })(props);
